export const RI005 = {
    submitApproval: 'api/order/v2/1.0/internal/order/submit-approval',
    Jwt: {
        // provisioning
        previewOrder: 'api/reference-implementation/ri005/1.0/internal/order/preview',
        submitOrder: 'api/reference-implementation/ri005/1.0/internal/order/submit',
        reSubmit: 'api/reference-implementation/ri005/1.0/internal/order/resubmit',
        costCalculation: 'ri-cost-calculation.json', // 'api/reference-implementation/ri005/1.0/internal/cost-calculation',
        internalPreviewOrder: 'api/reference-implementation/ri005/1.0/internal/preview/order',
        downloadTF: 'api/reference-implementation/ri005/1.0/internal/order',
    },
};
export default RI005;
